import React, { useState, useEffect } from 'react';
import style from "./style.scss";
import { setAuditObject } from '../../../../actions/products';
import { useDispatch } from 'react-redux';
import AuditErrCheckBoxContainer from '../../molecules/auditErrCheckBoxContainer';

const AuditProductRadioGroup = ({ checkBoxOptions, errType = "minCorrect" }) => {

    const errTypeAry = [
        { type: "minCorrect", value: "minor_error" },
        { type: "errWithDet", value: "major_error" }
    ]

    const [checkBoxData, setCheckBoxData] = useState({ ...checkBoxOptions })
    const dispatch = useDispatch();

    const selectedErrType = errTypeAry.find(item => item.type === errType)?.value

    useEffect(() => {
        if (checkBoxOptions[selectedErrType] && checkBoxOptions[selectedErrType].length > 0) {
            createObj(checkBoxOptions[selectedErrType], (Obj) => {
                dispatch(setAuditObject({ newCheckBoxData: Obj }));
            })
        }
    }, [])

    const handleSelectErr = (curr, ind, isOuterAry = true, subItem = { value: false }, subInd = 0) => {
        const tmpAry = [...checkBoxOptions[selectedErrType]]
        if (isOuterAry) {
            tmpAry[ind].value = !curr.value
        } else {
            tmpAry[ind].subnames[subInd].value = !subItem.value
        }
        setCheckBoxData({ ...checkBoxData, [selectedErrType]: [...tmpAry] })
        createObj(tmpAry, (Obj) => {
            dispatch(setAuditObject({ newCheckBoxData: Obj }));
        })
    }

    const createObj = (inputArray, cb) => {
        const outputObject = {}
        inputArray.forEach(item => {
            if (item.value) {
                if (item.subnames && item.subnames.length > 0) {
                    const subnamesArray = item.subnames.filter(subname => subname.value).map(subname => subname.name);
                    if (subnamesArray.length > 0) {
                        outputObject[item.name] = subnamesArray;
                    } else {
                        outputObject[item.name] = [];
                    }
                } else {
                    outputObject[item.name] = [];
                }
            }
        });
        cb(outputObject)
    }

    return (
        <div className={style["optItem"]}>
            {
                checkBoxData[selectedErrType]?.map((item, ind) => {
                    return (
                        <AuditErrCheckBoxContainer
                            item={item}
                            ind={ind}
                            handleSelectErr={handleSelectErr}
                            key={ind}
                        />
                    )
                })
            }
        </div>
    )
}

export default AuditProductRadioGroup